import type { PrefetchContext } from '@change-corgi/core/react/prefetch';

export async function prefetch(_context: PrefetchContext): Promise<void> {
	// do nothing for now
}
